import styled from "@emotion/styled"
import L1Title from "../l1/L1Title"
import L2Surface from "../l2/L2Surface"
import L3ValueLabel from "./L3ValueLabel"
import L2ControlGrid from "../l2/L2ControlGrid"
import L2ControlGridLayout from "../l2/L2ControlGridLayout"
import { MahcAssessmentDetails } from "../../../redux/selectMahcAssessment"
import { useMemo } from "react"

const L3MahcAssessmentRoot = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(2),
}))

const L3MahcAssessmentNotice = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(1),
	justifyContent: 'center',
	alignItems: 'center',
}))

interface L3MahcAssessmentProps {
	assessmentDetails: MahcAssessmentDetails,
	onScoreChange?: (score: number) => void,
}

const L3MahcAssessment = ({ assessmentDetails, onScoreChange }: L3MahcAssessmentProps) => {
	const {score, result} = useMemo(() => {
		let result = "MAHC Fall Risk Assessment is low"
		let score = 0
		for(const key in assessmentDetails) {
			if(assessmentDetails[key as keyof MahcAssessmentDetails].meetsCriteria) {
				score += assessmentDetails[key as keyof MahcAssessmentDetails].value
			}
		}
		if(score >= 4) {
			result = "MAHC Fall Risk Assessment is high"
		}
		onScoreChange?.(score)
		return { score, result }
	}, [assessmentDetails, onScoreChange])

	return (
		<L3MahcAssessmentRoot>
			<L3MahcAssessmentNotice>
				<L1Title tier={3} title="Score one point for each element 'yes'" />
				<L1Title tier={3} title="A score of 4 or more is considered a risk for falling" />
			</L3MahcAssessmentNotice>
			<L2ControlGrid layout={L2ControlGridLayout.FlowColumn} columnCount={2}>
				<div>
					<L1Title tier={3} title="Points" />
					{
						Object.keys(assessmentDetails).map(key => (
							<p key={key}>{assessmentDetails[key as keyof MahcAssessmentDetails].meetsCriteria ? assessmentDetails[key as keyof MahcAssessmentDetails].value : 0}</p>
						))
					}
				</div>
				<div>
					<L1Title tier={3} title="Element" />
					{
						Object.keys(assessmentDetails).map(key => (
							<p key={key}>{assessmentDetails[key as keyof MahcAssessmentDetails].label}</p>
						))
					}
				</div>
			</L2ControlGrid>
			<L1Title tier={3} title="MAHC Fall Risk Assessment Result" />
			<L2Surface>
				<L2ControlGrid layout={L2ControlGridLayout.FlexRow} columnCount={1}>
					<L3ValueLabel value={score} size="max" validity={null} />
					<L1Title tier={3} title={result} />
				</L2ControlGrid>
			</L2Surface>
		</L3MahcAssessmentRoot>
	)
}

export default L3MahcAssessment